<template>
    <div v-if="aeroporto.selecionado !== 'não'" id="aeroportoDados">

      <Aeroporto @aeroporto-selecionado="receberEmitAeroporto" 
                 @endereco-aeroporto-selecionado="receberEmitEnderecoAeroporto"
      v-model:aeroporto="this.aeroporto.detalhes.nomeAeroporto" />

      <label for="dataVoo" class="required">Data do Voo:</label>
      <input type="date" id="dataVoo" v-model="aeroporto.detalhes.dataVoo"  @change="informarAeroporto"/>

      <br />
      <label for="numeroVoo" class="required">Número do Voo:</label>
      <input type="text" id="numeroVoo" v-model="aeroporto.detalhes.numeroVoo"  @keypress="informarAeroporto"/>

      <br />
      <label for="numeroVoo" class="required">Horário {{this.getRotuloChegadaOuPartida()}} do Voo:</label>
      <input type="time" id="numeroVoo" v-model="aeroporto.detalhes.horarioChegadaPartidaVoo"  @change="informarAeroporto"/>

      <br />
      <label for="origemDestinoVoo" class="required">Origem/Destino Voo:</label>
      <input type="text" id="origemDestinoVoo" v-model="aeroporto.detalhes.origemDestinoVoo"  @keypress="informarAeroporto"/>

      <br />
      <label for="ciaAerea" class="required">Cia Aérea:</label>
      <input type="text" id="ciaAerea" v-model="aeroporto.detalhes.ciaAerea"  @keypress="informarAeroporto"/>

    </div>
</template>
  
<script>

import Aeroporto from '@/components/Aeroporto.vue';

export default {
  name: 'aeroporto',
  emits: ['aeroporto-informado', 'endereco-aeroporto-informado'],
  props: {
    isAeroporto: {
      type: String,
      default: null
    },
    dataMinima: Date
  },

  components: {
    Aeroporto
  },

  data() {
    return {
      aeroporto: {
        selecionado: 'não',  // valor inicial
        detalhes: {
          dataVoo: '',
          numeroVoo: '',
          horarioChegadaPartidaVoo: '',
          origemDestinoVoo: '',
          ciaAerea: '',
          nomeAeroporto: ''

        }
      },
      enderecoAeroporto:{} // estou enviando separado do nó aeroporto
                           // pois não quero que esta informação faça
                           // parte do json que será enviado ao servidor
                           // mas apenas para controle de tela
    };
  },

  created() {
    this.aeroporto.selecionado = this.isAeroporto;
  },

  methods: {

    receberEmitAeroporto(a) {

      this.aeroporto.selecionado = this.isAeroporto;
      this.aeroporto.detalhes.nomeAeroporto = a;
      this.informarAeroporto(); //quando receber o aeroporto selecionado (combo)
                                //lançar emits
    },

    receberEmitEnderecoAeroporto(e) {
      this.enderecoAeroporto = e;
      this.informarAeroporto(); //quando receber o aeroporto selecionado (combo) 
                                //lançar emits
    },

    informarAeroporto() {
      this.$emit('aeroporto-informado', this.aeroporto);
      this.$emit('endereco-aeroporto-informado', this.enderecoAeroporto);
    },

    getRotuloChegadaOuPartida(){
      if (this.aeroporto.selecionado === 'Origem'){
        return 'Chegada';
      } else if (this.aeroporto.selecionado === 'Destino'){
        return 'Partida';
      }
    }
  },

  mounted() {
    
  },

  watch: {
    isAeroporto(newValue) {
      this.aeroporto.selecionado = newValue;
    },
  }

};
</script>
  
<style src="../css/transporte.css"></style>